export interface IMyCV {
  createdOn: Date;
  isRendered: boolean;
  id: string;
  title: string;
  type: string;
  language: string;
  secretKey?: string;
  thumbnailUri?: string;
  isDefault?: boolean;
  actions?: {
    canDelete: boolean;
    canDownloadPdf: boolean;
    canDuplicate: boolean;
    canShare: boolean;
    canUpdate: boolean;
  };
}

export enum NavHeaderButtonTypeEnum {
  CCV = 'create'
}

export enum SectionSummaryType {
  WorkExp = 'WorkExp',
  EducationExp = 'EducationExp'
}
